import request from '@/utils/request' //引入封装好的 axios 请求

// 需求统计
export function queryXQStatistics (data = {}) {
    return request({
        url: '/api/credit/financial/effectByParam',
        method: 'post',
        data: data
    })
}

// 融资统计
export function queryRZStatistics (data = {}) {
    return request({
        url: '/api/credit/financial/creditByParam',
        method: 'post',
        data: data
    })
}

//待推荐企业列表
export function JgList (data = {}) {
    return request({
        url: '/api/loan/apply/JgList',
        method: 'post',
        data: data
    })
}


//推荐银行列表
export function bankList (data = {}) {
    return request({
        url: '/api/v1/user/bankList',
        method: 'post',
        data: data
    })
}

//向推荐银行
export function recommend (data = {}) {
    return request({
        url: '/api/credit/import/recommend',
        method: 'post',
        data: data
    })
}

//查询推荐历史记录
export function jgHistoryList (data = {}) {
    return request({
        url: '/api/loan/apply/jgHistoryList',
        method: 'post',
        data: data
    })
}


//查询历史记录详情
export function jgHistoryDetail (data = {}) {
    return request({
        url: '/api/loan/apply/jgHistoryDetail',
        method: 'post',
        data: data
    })
}


//企业推荐情况统计
export function financeEffect (data = {}) {
    return request({
        url: '/api/loan/apply/financeEffect',
        method: 'post',
        data: data
    })
}

//关注
export function followApply (data = {}) {
    return request({
        url: '/api/loan/apply/followApply',
        method: 'post',
        data: data
    })
}



//全部关注
export function bathFollow (data = {}) {
    return request({
        url: '/api/loan/apply/bathFollow',
        method: 'post',
        data: data
    })
}

//查询授信放款信息
export function expertLoanDetailById (data = {}) {
    return request({
        url: 'api/loan/apply/expertLoanDetailById',
        method: 'post',
        data: data
    })
}


//查询审批列表

export function list (data = {}) {
    return request({
        url: '/api/credit/product/list',
        method: 'post',
        data: data
    })
}



//审批结果

export function examine (data = {}) {
    return request({
        url: '/api/credit/product/examine',
        method: 'post',
        data: data
    })
}

//查询审批历史

export function selectHistoryList (data = {}) {
    return request({
        url: '/api/credit/product/selectHistoryList',
        method: 'post',
        data: data
    })
}

//上报历史记录

export function businessReportHistoryRecord (data = {}) {
    return request({
        url: '/api/v1/user/businessReportHistoryRecord',
        method: 'post',
        data: data
    })
}

//业务报送监管
export function platformSubmissionRecord (data = {}) {
    return request({
        url: '/api/credit/financial/platformSubmissionRecord',
        method: 'post',
        data: data
    })
}



//业务报送银行列表
export function bank (data = {}) {
    return request({
        url: '/api/v1/user/bankList',
        method: 'post',
        data: data
    })
}


//业务报送银行列表
export function reportedByBankingRecord (data = {}) {
    return request({
        url: '/api/credit/financial/reportedByBankingRecord',
        method: 'post',
        data: data
    })
}


//查看产品详情
export function detail (data = {}) {
    return request({
        url: '/api/credit/product/detail',
        method: 'post',
        data: data
    })
}


//有贷无贷款
export function loanAndNoLoanAmount (data = {}) {
    return request({
        url: '/api/credit/financial/loanAndNoLoanAmount',
        method: 'post',
        data: data
    })
}
//获取推荐银行列表
export function BankList (data = {}) {
    return request({
        url: '/api/loan/apply/bankList',
        method: 'post',
        data: data
    })
}



//用户统计
export function erTotalByParam (data = {}) {
    return request({
        url: '/api/credit/financial/userTotalByParam',
        method: 'post',
        data: data
    })
}




//获取推荐银行列表
export function frontPageBankList (data = {}) {
    return request({
        url: '/api/v1/user/frontPageBankList',
        method: 'post',
        data: data
    })
}




//获取推荐银行列表
export function detailByExamineId (data = {}) {
    return request({
        url: '/api/credit/product/detailByExamineId',
        method: 'post',
        data: data
    })
}


export function getProductType (data = {}) {
    return request({
        url: '/api/credit/dictionary/selectByCode',
        method: 'post',
        params: data
    })
}

//查询已申请产品清单
export function applyProList (data = {}) {
    return request({
        url: '/api/credit/application/applyProList ',
        method: 'post',
        data: data
    })
}


export function applyBankList (data = {}) {
    return request({
        url: '/api/credit/application/applyBankList ',
        method: 'post',
        data: data
    })
}




export function execute (data = {}) {
    return request({
        url: '/api/credit/execute/list',
        method: 'post',
        data: data
    })
}

export function selectReportData (data = {}) {
    return request({
        url: '/api/v1/report/selectReportData',
        method: 'post',
        data: data
    })
}